import { Fragment, useState } from "react";

import { useHistory } from "react-router-dom";

import Box from "@/components/Box";
import Circle from "@/components/Circle";
import UserIcon from "@/images/user.svg?react";
import ChevronComponent from "@/tpo/Chevron";
import Menu from "@/tpo/Menu";
import ButtonV2 from "@/v2/Buttons";
import styled from "styled-components";

import Divider from "../../Divider";

const MenuItemStyled = styled(Box)`
  font-size: 14px;
  line-height: 150%;
  color: white;
  padding: 12px 16px;
  cursor: pointer;
  border-radius: 4px;

  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
    color: white;
  }
`;

export default function AccountsMenu({ accounts = [], bg: _bg = "dark", display }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const history = useHistory();

  const handleItemClick = (to, newTab) => {
    if (newTab) {
      window.open(to, "_blank");
    } else {
      history.push(to);
    }
    setMenuOpen(false);
  };

  const bg = !menuOpen ? _bg : "#282828";

  const filteredAccounts = accounts.filter(section => section.links.length > 0);

  return (
    <Menu
      opened={menuOpen}
      onChange={setMenuOpen}
      trigger="click"
      placement="bottom-start"
      allowedPlacements={["bottom-start"]}
    >
      <Menu.Target>
        <ButtonV2
          leftIcon={<UserIcon fill="white" width={20} />}
          rightIcon={
            <ChevronComponent direction={menuOpen ? "top" : "bottom"} width={5} fill="white" />
          }
          p={16}
          letterSpacing="unset"
          textTransform="unset"
          fontSize={16}
          gap={10}
          size={null}
          color="transparent"
          bg={bg}
          height={[48, 48, 60]}
          borderRadius={0}
          display={display}
        >
          Accounts
        </ButtonV2>
      </Menu.Target>
      <Menu.Dropdown
        bg={bg}
        borderRadius={12}
        minWidth={240}
        px="8px"
        py={28}
        data-component-name="AccountsMenu"
        borderTopLeftRadius={0}
      >
        {filteredAccounts
          .filter(section => section.links.length > 0)
          .map((section, idx) => (
            <Fragment key={section.label}>
              <Box pl="8px" key={section.label}>
                <Box
                  color="midGrey"
                  fontFamily="gilroyMedium"
                  fontSize={14}
                  lineHeight="150%"
                  pl="8px"
                  pb="16px"
                  pr="12px"
                >
                  {section.label}
                </Box>
                <Box>
                  {section.links.map((link, index) => (
                    <MenuItemStyled
                      key={link.label}
                      onClick={() => handleItemClick(link.href || link.to, link.newTab)}
                      fontFamily="gilroyMedium"
                    >
                      {link.activeTest?.() && (
                        <Circle bg="green" size={5} position="relative" left="-15px" top="10px" />
                      )}
                      {link.label}
                    </MenuItemStyled>
                  ))}
                </Box>
              </Box>
              {idx < filteredAccounts.length - 1 && (
                <Divider color="midGrey" my="24px" key={`divider-${idx}`} />
              )}
            </Fragment>
          ))}
      </Menu.Dropdown>
    </Menu>
  );
}
